import { Avatar, Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useSWRConfig } from "swr";
import useSWRMutation from "swr/mutation";
import { useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";

import avatar1 from "../../../media/svg/Avatar/Avatar1.svg";
import avatar2 from "../../../media/svg/Avatar/Avatar2.svg";
import avatar3 from "../../../media/svg/Avatar/Avatar3.svg";
import avatar4 from "../../../media/svg/Avatar/Avatar4.svg";
import avatar5 from "../../../media/svg/Avatar/Avatar5.svg";
import avatar6 from "../../../media/svg/Avatar/Avatar6.svg";
import avatar7 from "../../../media/svg/Avatar/Avatar7.svg";
import avatar8 from "../../../media/svg/Avatar/Avatar8.svg";
import avatar9 from "../../../media/svg/Avatar/Avatar9.svg";
import avatar10 from "../../../media/svg/Avatar/Avatar10.svg";
import avatar11 from "../../../media/svg/Avatar/Avatar11.svg";
import avatar12 from "../../../media/svg/Avatar/Avatar12.svg";
import avatar13 from "../../../media/svg/Avatar/Avatar13.svg";
import avatar14 from "../../../media/svg/Avatar/Avatar14.svg";
import avatar15 from "../../../media/svg/Avatar/Avatar15.svg";
import avatar16 from "../../../media/svg/Avatar/Avatar16.svg";
import avatar17 from "../../../media/svg/Avatar/Avatar17.svg";
import avatar18 from "../../../media/svg/Avatar/Avatar18.svg";

import { fetcherPatch } from "../../../services/fetcher";
import {
  getSettingState,
  setLocalAvatar,
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../redux/features/settingSlice";
import LoginFooter from "./../LoginPage/LoginFooter/index";
import EditProfilePictureNavBar from "./../EditProfile/ProfilePicture/EditProfilePictureNavBar/index";

const CustomSelectAvatar = ({ footer, header }) => {
  const [avatar, setAvatar] = useState("");
  const [selectAvatar, setSelectAvatar] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const theme = useTheme();
  const { mutate } = useSWRConfig();
  const { userData, localAvatar } = useSelector(getSettingState);

  const avatarData = [
    { id: 1, src: avatar1 },
    { id: 2, src: avatar2 },
    { id: 3, src: avatar3 },
    { id: 4, src: avatar4 },
    { id: 5, src: avatar5 },
    { id: 6, src: avatar6 },
    { id: 7, src: avatar7 },
    { id: 8, src: avatar8 },
    { id: 9, src: avatar9 },
    { id: 10, src: avatar10 },
    { id: 11, src: avatar11 },
    { id: 12, src: avatar12 },
    { id: 13, src: avatar13 },
    { id: 14, src: avatar14 },
    { id: 15, src: avatar15 },
    { id: 16, src: avatar16 },
    { id: 17, src: avatar17 },
    { id: 18, src: avatar18 },
  ];

  useEffect(() => {
    return () => {
      dispatch(setLocalAvatar(null));
    };
  }, [dispatch]);

  const { trigger, isMutating } = useSWRMutation(
    [`${process.env.REACT_APP_API}/auth/profile/update/`, tokenStorage],
    fetcherPatch,
    {
      onSuccess: () => {
        dispatch(setSnackbarMode(true));
        dispatch(setSnackbarTitle("Your avatar has been updated"));

        mutate(`${process.env.REACT_APP_API}/auth/profile/${userData}/`);
        if (footer) {
          navigate("/login/editcategory");
        }
        if (header) {
          navigate("/profile/editprofile");
        }
      },
      onError: (e) => {
        // dispatch(setSnackbarMode(true));
        // dispatch(setSnackbarTitle("If you are using VPN, disconnect it"));
        if (e.request.status === 400) {
          dispatch(setSnackbarMode(true));
          dispatch(
            setSnackbarTitle(JSON.parse(e.request.responseText)?.avatar[0])
          );
        }
        if (e.request.statusText === "Unauthorized") {
          navigate("/profile");
        }
      },
    }
  );

  const handleClickAvatars = (data) => {
    if (data !== "upload") {
      setAvatar("");
      setSelectAvatar(data.id);
      dispatch(setLocalAvatar(data.src));
    }
  };

  const handleSetInput = (e) => {
    setAvatar(e.target.value);
    dispatch(setLocalAvatar(URL.createObjectURL(e.target.files[0])));
    setSelectAvatar("upload");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const response = await fetch(localAvatar);
    const blob = await response.blob();

    if (event.target.avatar.files[0]?.size > 3000000) {
      dispatch(setSnackbarMode(true));
      dispatch(setSnackbarTitle("The maximum image size is 3 MB"));
      return;
    }
    if (event.target.avatar.files[0]) {
      formData.append("avatar", event.target.avatar.files[0]);
    } else {
      selectAvatar && formData.append("avatar", blob, "avatar.svg");
    }

    try {
      await trigger(formData);
    } catch {}
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 xxs={6}>
        <Box
          onClick={() => handleClickAvatars("upload")}
          sx={{
            position: "relative",
            overflow: "hidden",
            p: "3px",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "164px",
              borderRadius: "16px",
              boxShadow: `0px 0px 0px 2px ${
                selectAvatar === "upload" && avatar !== ""
                  ? theme.palette.primary.main
                  : theme.palette.black.main
              }`,
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box component={"form"} onSubmit={handleSubmit}>
              <input
                type='file'
                name='avatar'
                accept={"image/png, image/jpeg, image/jpg, image/svg"}
                value={avatar}
                onChange={(e) => handleSetInput(e)}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              {footer && (
                <LoginFooter type='editAvatar' disabled={isMutating} />
              )}

              {header && (
                <EditProfilePictureNavBar
                  disabled={isMutating || (!avatar && !localAvatar)}
                />
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "22px",
              }}
            >
              Upload from
            </Typography>
            <Typography
              sx={{
                fontSize: "22px",
              }}
            >
              your device
            </Typography>
          </Box>
        </Box>
      </Grid2>
      {avatarData.map((row) => {
        return (
          <Grid2 key={row.id} xxs={6}>
            <Box
              onClick={() => handleClickAvatars(row)}
              sx={{
                position: "relative",
                overflow: "hidden",
                p: "3px",
                cursor: "pointer",
              }}
            >
              <Avatar
                alt={"avatar"}
                src={row.src}
                sx={{
                  width: "100%",
                  height: "164px",
                  borderRadius: "16px",
                  boxShadow: `0px 0px 0px 2px ${
                    selectAvatar === row.id
                      ? theme.palette.primary.main
                      : theme.palette.black.main
                  }`,
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  backgroundColor: "whiteDisabled.main",
                  top: 2,
                  bottom: 2,
                  left: 2,
                  right: 2,
                  borderRadius: "16px",
                  opacity: 0,
                }}
              ></Box>
            </Box>
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default CustomSelectAvatar;
